module.exports = __webpack_public_path__ + "img/audio-icon.56b525c3.svg";